import { Application } from 'stimulus'
import '@stimulus/polyfills'

window.Stimulus = Application.start()
